import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19aca378 = () => interopDefault(import('../pages/401/index.vue' /* webpackChunkName: "pages/401/index" */))
const _2068e508 = () => interopDefault(import('../pages/forbidden/index.vue' /* webpackChunkName: "pages/forbidden/index" */))
const _ffb7d27c = () => interopDefault(import('../pages/demo/dlocal/index.vue' /* webpackChunkName: "pages/demo/dlocal/index" */))
const _7b02d3f4 = () => interopDefault(import('../pages/demo/dlocal2/index.vue' /* webpackChunkName: "pages/demo/dlocal2/index" */))
const _8a0fcdaa = () => interopDefault(import('../pages/demo/gradient/index.vue' /* webpackChunkName: "pages/demo/gradient/index" */))
const _37e2ba3a = () => interopDefault(import('../pages/demo/pay/index.vue' /* webpackChunkName: "pages/demo/pay/index" */))
const _5a9a5852 = () => interopDefault(import('../pages/demo/rich/index.vue' /* webpackChunkName: "pages/demo/rich/index" */))
const _5c7c4c19 = () => interopDefault(import('../pages/sites/_sid/index.vue' /* webpackChunkName: "pages/sites/_sid/index" */))
const _2eeb8255 = () => interopDefault(import('../pages/preview/_sid/_lang/_pageid/index.vue' /* webpackChunkName: "pages/preview/_sid/_lang/_pageid/index" */))
const _5b6ccec4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/401",
    component: _19aca378,
    name: "401"
  }, {
    path: "/forbidden",
    component: _2068e508,
    name: "forbidden"
  }, {
    path: "/demo/dlocal",
    component: _ffb7d27c,
    name: "demo-dlocal"
  }, {
    path: "/demo/dlocal2",
    component: _7b02d3f4,
    name: "demo-dlocal2"
  }, {
    path: "/demo/gradient",
    component: _8a0fcdaa,
    name: "demo-gradient"
  }, {
    path: "/demo/pay",
    component: _37e2ba3a,
    name: "demo-pay"
  }, {
    path: "/demo/rich",
    component: _5a9a5852,
    name: "demo-rich"
  }, {
    path: "/sites/:sid",
    component: _5c7c4c19,
    name: "sites-sid"
  }, {
    path: "/preview/:sid?/:lang?/:pageid",
    component: _2eeb8255,
    name: "preview-sid-lang-pageid"
  }, {
    path: "/",
    component: _5b6ccec4,
    name: "index"
  }, {
    path: "/:lang/",
    component: _5b6ccec4,
    props: true,
    name: "SiteLangIndexPage"
  }, {
    path: "/:lang/:pageid",
    component: _5b6ccec4,
    props: true,
    name: "SiteLangPagePage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
